var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerfilUsuario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.145,
    height: 54.143,
    viewBox: "0 0 54.145 54.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "usuario-de-perfil_1_",
    "data-name": "usuario-de-perfil (1)",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76139",
    "data-name": "Trazado 76139",
    d: "M27.073,0A27.071,27.071,0,1,0,54.145,27.072,27.073,27.073,0,0,0,27.073,0Zm0,8.095a8.954,8.954,0,1,1-8.953,8.954A8.955,8.955,0,0,1,27.073,8.1Zm-.006,38.97a19.868,19.868,0,0,1-12.938-4.771,3.816,3.816,0,0,1-1.339-2.9,9.03,9.03,0,0,1,9.075-9.028H32.283a9.018,9.018,0,0,1,9.06,9.028,3.806,3.806,0,0,1-1.338,2.9A19.862,19.862,0,0,1,27.067,47.066Z",
    fill: "#18a8a2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfilUsuario);
export default __webpack_public_path__ + "static/media/perfil-usuario.ff00d3c7a96631369cdbbf6faa11aff5.svg";
export { ForwardRef as ReactComponent };